import React from "react";
import {
    Box,
    Button,
    Heading,
    Layer,
    Page,
    Text,
    Tip,
    Select,
    TextArea,
    Paragraph,
} from "grommet";
import { useLocation } from "react-router-dom";
import useBook from "../../hooks/useBook";
import useToc from "../../hooks/useToc";
import useTocRecord from "../../hooks/useTocRecord";
import useTableau from "../../hooks/useTableau";
import useTableauRecord from "../../hooks/useTableauRecord";
import usePsnorder from "../../hooks/usePsnorder";
import useInst from "../../hooks/useInst";

import PageMainCanvas from "./PageMainCanvas";
import { HiOutlineBuildingOffice } from "react-icons/hi2";

import { useRecoilState } from "recoil";
import {
    libraryBooks,
    libraryTocs,
    libraryTableaux,
    instDataLibrary
} from "../../recoils/library";
import { table } from "console";
import { Add, CaretDown, Close, ShareRounded, StatusInfo } from "grommet-icons";
import LoadingSign from "../../shared_comp/LoadingSign";
import SearchInstModal from "../../modals/SearchInstModal";
import getColors from "../../functions/getColors";
import { BookToc } from "../../config/types";

interface InstDataFormat {
    inst_id: number;
    inst_info: any;
    inst_check: boolean;
    tocs: any[];
}
interface DataUnitFormat {
    unit_id: number;
    inst_id: number;
    inst_index?: number;
    data_type: string;
    data_year: number|null;
    data_date: string;
    book_id: number;
    book_author?: string;
    book_category?: string;
    book_type?: string;
    book_title: string;
    book_numeration?: string;
    book_publisher?: string;
    toc_id?: number;
    toc_title?: string;
    alphabet?: string;
}

const PageInstMain = () => {
    let location = useLocation();
    const id_list = location.hash.split("#").pop() || "";
    const [instIds, setInstIds] = React.useState<number[]>([]);
    const [instInfos, setInstInfos] = React.useState<any>([]);

    const [selectedInstIds, setSelectedInstIds] = React.useState<any>([]);

    let ids = id_list.split("&");

    const [calledTocsInstname, setCalledTocsInstname] = React.useState<any>([]);
    const [readyLibraryTocs, setReadyLibraryTocs] = React.useState<any>(false);

    const [instDataList, setInstDataList] = React.useState<any>([]);
    const [readyInstData, setReadyInstData] = React.useState<any>(false);

    const [libraryBooksData, setLibraryBooksData] =
        useRecoilState(libraryBooks);
    const [libraryTocsData, setLibraryTocsData] = useRecoilState(libraryTocs);
    const [instDataLibraryData, setInstDataLibraryData] =
        useRecoilState(instDataLibrary);

    const [readyShowList, setReadyShowList] = React.useState<any>(false);
    const [showDataList, setShowDataList] = React.useState<any>([]);
    const [filteredDataList, setFilteredDataList] = React.useState<any>([]);

    const getInsts = async (inst_ids: any) => {
        let res = await useInst.getInstsByIds(inst_ids);
        return res.insts;
    };
    const getTocsByName = async (iname: any) => {
        const res = await useToc.getTocSearch([iname]);
        console.log("[getTocsInfo]", res);
        // find exact match with iname
        let tocs = null;
        tocs = res.tocs.filter((p: any) => p.toc_title === iname);
        return tocs;
    };
    const getBookInfo = async (book_id: number) => {
        let book_info = null;
        let res = await useBook.getBookById(book_id.toString());
        book_info = res.book;
        return book_info;
    };
    const getTocInfoFromLibraryById = (toc_id: number) => {
        let toc_info = null;
        toc_info = libraryTocsData.filter(
            (p: any) => p.toc_id === toc_id
        )[0];
        return toc_info;
    };
    const getBookInfoFromLibrary = (book_id: number) => {
        let book_info = null;
        book_info = libraryBooksData.filter(
            (p: any) => p.book_id === book_id
        )[0];
        return book_info;
    };
    const getInstDataFromLibrary = (inst_id: number) => {
        let inst_data = null;
        inst_data = instDataLibraryData.filter(
            (p: any) => p.inst_id === inst_id
        )[0];
        return inst_data;
    };
    const getInstTocData = async (inst_data: any) => {
        let inst_tocs = null;
        let res_tocs = await useInst.getTocsByInstId(inst_data.inst_id);
        console.log("getInstTocData", res_tocs);
        if (res_tocs) {
            inst_tocs = res_tocs;
            inst_data.tocs = res_tocs;
            inst_data.inst_check = true;
            setInstDataLibraryData([...instDataLibraryData, inst_data]);
            return inst_tocs;
        } else {
            return [];
        }
    };

    React.useEffect(() => {
        setReadyInstData(false);
        let ids_n = ids.map((id) => parseInt(id));
        setInstIds(ids_n);
        setSelectedInstIds(ids_n);
        // console.log("PageInstMain", ids_n);

        // step1 : get inst info from inst_id
        const receiveInstInfo = async () => {
            let res = await getInsts(ids_n);
            console.log("receiveInstInfo", res);
            setInstInfos(res);
        };

        setCalledTocsInstname([]);
        setReadyInstData(false);
        setReadyShowList(false);
        setInstDataList([]);
        setAddMoreInst(false);
        setShowDataList([]);
        setFilteredDataList([]);
        setModificationMode(false);
        setNewShowDataList([]);
        setSendModification(false);
        receiveInstInfo();
    }, []);

    const [instTocs, setInstTocs] = React.useState<any>([]);
    const [nInstTocs, setNInstTocs] = React.useState<any>(0);
    const [tocsByInst, setTocsByInst] = React.useState<any>([]);
    React.useEffect(() => {
        setAddMoreInst(false);
        if (instInfos.length ===ids.length) {
            // check toc and book library
            console.log("exist library books and tocs", libraryBooksData, libraryTocsData)
            let tocs_to_library: any = [];
            const n_inst = instInfos.length;
            let count = 0;
            instInfos.forEach((inst_info: any) => {
                
                let inst_name = inst_info.inst.primaryname;
                getTocsByName(inst_name).then((tocs: any) => {
                    // console.log("inst_info count", count)
                    count += 1;
                    // check book in library
                    // console.log("getTocByName", tocs)
                    tocs_to_library.push(...tocs);
                    let new_tocs_by_inst = {inst_id: inst_info.inst.inst_id,tocs: tocs};
                    setTocsByInst([...tocsByInst, new_tocs_by_inst]);
                    if(n_inst === count) {
                    
                        let new_library_tocs = [...libraryTocsData, ...tocs_to_library];
                        setLibraryTocsData(new_library_tocs);
                        setInstTocs(tocs_to_library);
                        setNInstTocs(tocs_to_library.length);
                        // console.log("get all tocs of insts", tocs_to_library, n_inst, count)
                    }
                });

            });
        }
    }, [instInfos]);
    React.useEffect(()=>{
        if(nInstTocs>0 && instTocs.length===nInstTocs){
            console.log("instTocs", instTocs)
            let books_to_library: any = [];
            let count = 0;
            instTocs.forEach((toc: any) => {
                
                let book_in_library = getBookInfoFromLibrary( toc.book_id);
                        
                if (!book_in_library) {
                    getBookInfo(toc.book_id).then(
                        (book_info: any) => {
                            count += 1;
                            console.log(count, "| tocs forEach and book in Library |", toc, book_info)
                            books_to_library.push(book_info);
                            if (nInstTocs === count) {
                                // console.log("number check n_inst, count, n_tocs, toc_count", n_inst, count, n_tocs, toc_count)
                                let new_library_tocs = [...libraryTocsData, ...instTocs];

                                setLibraryTocsData(new_library_tocs);
                                let new_library_books = [...libraryBooksData, ...books_to_library];
                                setLibraryBooksData(new_library_books);
                                setReadyLibraryTocs(true);
                                console.log(count, "new library books and tocs", new_library_books, new_library_tocs );
                            }
                        }
                    );
                } else {
                    count += 1;
                    if (nInstTocs === count) {
                        setReadyLibraryTocs(true);
                    }
                }
            })
        }
    },[instTocs])

    React.useEffect(() => {
        if (readyLibraryTocs) {
            let inst_data_list: any = [];
            const n_inst = instInfos.length;
            let count = 0;
            instInfos.forEach((inst_info: any) => {
                count += 1;
                let instData: InstDataFormat = {
                    inst_id: inst_info.inst.inst_id,
                    inst_info: inst_info,
                    inst_check: false,
                    tocs: [],
                };

                let inst_data_in_library = getInstDataFromLibrary(
                    instData.inst_id
                );
                if (inst_data_in_library) {
                    inst_data_list.push(inst_data_in_library);
                    if (n_inst === count) {
                        setInstDataList(inst_data_list);
                        setReadyInstData(true);
                    }
                } else {
                    // get inst_data
                    getInstTocData(instData).then((tocs: any) => {
                        console.log("getInstTocData return", instData, tocs);
                        inst_data_list.push(instData);
                        if (n_inst === count) {
                            setInstDataList(inst_data_list);
                            setReadyInstData(true);
                        }
                    });
                }
            });
        }
    }, [readyLibraryTocs]);

    React.useEffect(() => {
        let n_unit_count = 0;
        const makeUnitIdUnique = () => {
            n_unit_count += 1;
            let hour = new Date().getHours();
            let minute = new Date().getMinutes();
            let second = new Date().getSeconds();
            let milisecond = new Date().getMilliseconds();
            let n_unit_number =
                n_unit_count +
                1 +
                100 *
                    parseInt(
                        hour + "" + minute + "" + second + "" + milisecond
                    );
            n_unit_number += Math.floor(Math.random() * 9000) + 1000;
            return n_unit_number;
        };
        if (readyInstData) {
            console.log("instDataList", instDataList, libraryTocsData);
            // convert toc to data unit
            let show_data_list: any = [];
            const n_inst = instDataList.length;
            let inst_count = 0;
            instDataList.forEach((inst_data: any) => {
                inst_count += 1;
                const n_tocs = inst_data.tocs.length;
                let toc_count = 0;
                inst_data.tocs.forEach((toc: any) => {
                    toc_count += 1;
                    // console.log("toc", toc)
                    let book_info = null;
                    let toc_info = null;
                    // check toc in library
                    toc_info = getTocInfoFromLibraryById(toc.toc_id);
                    console.log(toc_count, "toc_info from library", toc_info)
                    if (toc_info) {
                        // check book in library
                        book_info = getBookInfoFromLibrary(toc_info.book_id);
                        if (book_info) {
                            // make unit_id
                            let n_unit_id = makeUnitIdUnique();
                            let numeration = book_info.numeration;
                            let base_year = null
                            if(numeration) {
                                base_year = parseInt(numeration.split('(')[1].split('-')[0]);
                            }
                            let data: DataUnitFormat = {
                                unit_id: n_unit_id,
                                inst_id: inst_data.inst_id,
                                inst_index:
                                    instIds.indexOf(inst_data.inst_id) + 1,
                                data_type: "toc",
                                data_year: base_year,
                                data_date: "",
                                book_id: book_info.book_id,
                                book_author: book_info.authors,
                                book_category: book_info.book_category,
                                book_type: book_info.book_type,
                                book_title: book_info.book_title,
                                book_numeration: book_info.numeration,
                                book_publisher: book_info.publisher,
                                toc_id: toc.toc_id,
                                toc_title: toc.toc_title,
                                alphabet: "",
                            };
                            show_data_list.push(data);
                            // console.log("PUSH show_data_list", show_data_list.length,show_data_list, data)
                            if (n_inst === inst_count && n_tocs === toc_count) {
                                console.log("show_data_list", show_data_list);
                                show_data_list.sort((a: any, b: any) => {
                                    if (a.data_year === b.data_year) {
                                        if (a.data_date === b.data_date) {
                                            return 0;
                                        } else {
                                            return a.data_date < b.data_date ? -1 : 1;
                                        }
                                    } else {
                                        return a.data_year < b.data_year ? -1 : 1;
                                    }
                                });
                                setShowDataList(show_data_list);
                                setReadyShowList(true);

                            }
                        } else {
                            console.log(
                                "ERROR making book library",
                                libraryBooksData,
                                toc_info
                            );
                        }
                    } else {
                        console.log(
                            "ERROR making toc library",
                            libraryTocsData,
                            toc
                        );
                    }
                });
            });
        }
    }, [readyInstData]);

    React.useEffect(() => {
        // console.log("showDataList", showDataList);
        if(showDataList.length > 0){
            let new_show_list = showDataList.filter((d: any) => {
                return selectedInstIds.includes(d.inst_id);
            });
            setFilteredDataList(new_show_list);
            console.log("filteredDataList", showDataList, selectedInstIds, new_show_list);

        }
    }, [selectedInstIds]);

    const InstListBox = () => {
        const AInstButton = (props: any) => {
            let name = props.name;
            let name_ko = props.name_ko;
            let id = props.id;
            let pindex = instInfos.findIndex(
                (p: any) => p.inst.inst_id === id
            );
            return (
                <Tip
                    plain
                    content={
                        name_ko !== name && (
                            <Box
                                background="rgba(255,255,255, 0.9)"
                                align="center"
                                justify="center"
                            >
                                <Text size="10px">{name_ko}</Text>
                            </Box>
                        )
                    }
                >
                    <Button
                        margin={{ horizontal: "5px" }}
                        plain
                        label={
                            <Box
                                margin={{ vertical: "5px" }}
                                hoverIndicator
                                pad="10px"
                                round="5px"
                                direction="row"
                                align="center"
                                justify="center"
                                border={
                                    selectedInstIds.includes(id)
                                        ? { color: "black" }
                                        : { color: "grey" }
                                }
                                background={
                                    selectedInstIds.includes(id)
                                        ? "rgba(255,255,255,0.9)"
                                        : "rgba(255,255,255,0.1)"
                                }
                            >
                                <Text size="12px" margin={{ right: "2px" }}>
                                    {pindex + 1}
                                </Text>
                                <Text size="16px">{name}</Text>
                            </Box>
                        }
                        onClick={() => {
                            if (selectedInstIds.includes(id)) {
                                if (selectedInstIds.length === 1) {
                                    setSelectedInstIds(instIds);
                                } else {
                                    setSelectedInstIds( selectedInstIds.filter( (p: any) => p !== id) );
                                }
                            } else {
                                setSelectedInstIds([...selectedInstIds, id, ]);
                            }
                        }}
                    />
                </Tip>
            );
        };
        return (
            <Box
                pad="10px"
                round="5px"
                align="center"
                style={{ minHeight: "70px" }}
                flex={false}
            >
                <Text>
                    {instInfos.map((p: any) => (
                        <AInstButton
                            key={p.inst.inst_id}
                            name={p.inst.primaryname}
                            name_ko={p.inst.primaryname_ko}
                            id={p.inst.inst_id}
                        />
                    ))}
                </Text>
            </Box>
        );
    };

    // create a list of alphabet from A to Z
    const alphabetList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const [colorPalette, setColorPalette] = React.useState<any>([]);

    const [modificationMode, setModificationMode] = React.useState<any>(false);
    const [newShowDataList, setNewShowDataList] = React.useState<any>([]);

    const startModification = () => {
        setModificationMode(true);
        console.log("startModification", showDataList);

        // make copy of showDataList with alphabet numbering
        showDataList.forEach((d: any) => {
            let alphabet = alphabetList[instIds.indexOf(d.inst_id)];
            d.alphabet = alphabet;
        });
        console.log("startModification new list", showDataList);
        setNewShowDataList(showDataList);
        // make alphabet list
        let new_color_palette = getColors([]);
        setColorPalette(new_color_palette);
    };

    const [sendModification, setSendModification] = React.useState<any>(false);

    const AData = (props: any) => {
        let data = props.data;
        let pindex = props.pindex + 1;
        let toc_title = data.toc_title;
        if (toc_title) {
            toc_title = toc_title.replaceAll("ㅁ", " ");
            toc_title = toc_title.replaceAll("/", " / ");
            toc_title = toc_title.replaceAll("  ", " ");
        }

        const paList = alphabetList;
        const ChangeInstSetting = () => {
            let currentPA = data.alphabet;
            const [selectPA, setSelectPA] = React.useState<any>(currentPA);
            const paRender = (pa: any) => (
                <Box
                    pad={{ horizontal: "11px", vertical: "5px" }}
                    alignSelf="center"
                    background="white"
                    width="full"
                >
                    <Text size="15px" color="black">
                        {pa}
                    </Text>
                </Box>
            );
            const changePA = (props: any) => {
                let new_pa = props.pa;
                console.log("changePA", data.alphabet, new_pa);
                // change data.alphabet
                data.alphabet = new_pa;

                // change newShowDataList
                let new_list = newShowDataList;
                let index = new_list.findIndex(
                    (d: any) => d.unit_id === data.unit_id
                );
                new_list[index] = data;
                setNewShowDataList(new_list);
                setSelectPA(new_pa);
            };
            return (
                <Box
                    background={colorPalette[paList.indexOf(currentPA)]}
                    height="full"
                    align="center"
                    justify="center"
                    style={{ minWidth: "80px", maxWidth: "80px" }}
                >
                    <Select
                        dropHeight="small"
                        plain
                        icon={<CaretDown size="small" />}
                        valueLabel={
                            <Box
                                width="30px"
                                overflow="hidden"
                                align="center"
                                border={{
                                    color: "grey",
                                    size: "0.2px",
                                }}
                                background="white"
                            >
                                <Text size="15px" color="black">
                                    {currentPA}
                                </Text>
                            </Box>
                        }
                        options={paList}
                        onChange={(e: any) => {
                            console.log(data.alphabet, e.option);
                            changePA({ pa: e.option });
                        }}
                    >
                        {paRender}
                    </Select>
                </Box>
            );
        };
        const IndexBox = (props: any) => {
            let pindex = props.pindex;
            return (
                <Box
                    direction="column"
                    align="center"
                    justify="center"
                    height="full"
                    style={{ minWidth: "25px", maxWidth: "25px" }}
                >
                    <Box
                        width="25px"
                        height="25px"
                        round="2px"
                        border
                        align="center"
                        justify="center"
                    >
                        <Text size="15px">{pindex}</Text>
                    </Box>
                </Box>
            );
        };
        const YearBox = (props: any) => {
            let year = props.year;
            return (
                <Box
                    direction="column"
                    align="center"
                    justify="center"
                    height="full"
                    style={{ minWidth: "50px", maxWidth: "50px" }}
                >
                    <Box
                        height="25px"
                        round="2px"
                        align="center"
                        justify="center"
                    >
                        <Text size="15px">{year}</Text>
                    </Box>
                </Box>
            );
        };
        const BookInfo = (props: any) => {
            let book_title = props.book_title;
            let book_category = props.book_category;
            let book_author = props.book_author;
            let book_publisher = props.book_publisher;
            let book_numeration = props.book_numeration;
            let data_date = props.data_date;

            return (
                <Text size="15px">
                    <Text size="12px" margin={{ right: "10px" }}>
                        자료:{" "}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        [{book_category}]
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_author}
                    </Text>
                    <Text size="15px" margin={{ right: "10px" }}>
                        {book_title}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_numeration}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_publisher}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {data_date}
                    </Text>
                </Text>
            );
        };
        const TocInfo = (props: any) => {
            let toc_title = props.toc_title;
            return (
                <Box
                    direction="row"
                    align="center"
                    justify="start"
                    margin={{ bottom: "5px" }}
                >
                    <Text size="15px">
                        <Text size="12px" margin={{ right: "10px" }}>
                            목차:{" "}
                        </Text>
                        <Text size="15px" margin={{ right: "10px" }}>
                            {toc_title}
                        </Text>
                    </Text>
                </Box>
            );
        };

        return (
            <>
                {selectedInstIds.includes(data.inst_id) && (
                    <Box
                        width="90%"
                        flex={false}
                        direction="row"
                        alignSelf="center"
                        margin={{ horizontal: "10px", vertical: "5px" }}
                        elevation="large"
                        pad="10px"
                        round="5px"
                        background="rgba(255,255,255,0.9)"
                        align="start"
                        justify="between"
                    >
                        <Box
                            width="full"
                            direction="row"
                            align="center"
                            justify="start"
                        >
                            <IndexBox pindex={pindex} />
                            <YearBox year={data.data_year} />
                            <Box
                                direction="column"
                                margin={{ horizontal: "10px" }}
                            >
                                {/* book info */}
                                <Box
                                    direction="row"
                                    align="center"
                                    justify="start"
                                    margin={{ bottom: "5px" }}
                                >
                                    <BookInfo
                                        book_title={data.book_title}
                                        book_category={data.book_category}
                                        book_author={data.book_author}
                                        book_publisher={data.book_publisher}
                                        book_numeration={data.book_numeration}
                                        data_date={data.data_date}
                                    />
                                </Box>

                                {data.toc_title && (
                                    <TocInfo toc_title={toc_title} />
                                )}
                            </Box>
                        </Box>

                        {modificationMode && (
                            <Box
                                border
                                round="3px"
                                align="center"
                                justify="center"
                                height="full"
                                style={{ minWidth: "80px", maxWidth: "80px" }}
                            >
                                <ChangeInstSetting />
                            </Box>
                        )}
                    </Box>
                )}
            </>
        );
    };

    const [addMoreInst, setAddMoreInst] = React.useState<any>(false);

    const [modificationRecommand, setModificationRecommand] =
        React.useState<string>("");

    const RecommandTextBox = () => {
        let recommand_text = "KNUE_DATA_PERSON_MODIFICATION \n|";
        // add day and timestamp
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;
        let date = today.getDate();
        let hour = today.getHours();
        let minute = today.getMinutes();
        let second = today.getSeconds();
        let milisecond = today.getMilliseconds();
        let timestamp =
            "yr" +
            year +
            ":mo" +
            month +
            ":dt" +
            date +
            ":hr" +
            hour +
            ":mn" +
            minute +
            ":sc" +
            second +
            ":ms" +
            milisecond;
        recommand_text += timestamp + " \n|";

        newShowDataList.forEach((d: any) => {
            if (selectedInstIds.includes(d.inst_id)) {
                recommand_text += JSON.stringify(d) + " \n|";
            }
        });
        recommand_text += "END";
        return (
            <Box
                direction="column"
                style={{ minWidth: "500px", maxWidth: "500px" }}
                align="center"
                justify="center"
                pad="10px"
                height="full"
            >
                {/* <Box alignSelf="end">copy button</Box> */}
                <Box
                    alignSelf="center"
                    margin={{ top: "50px" }}
                    height="500px"
                    pad="10px"
                    align="center"
                    round
                    border
                    style={{ minWidth: "500px", maxWidth: "500px" }}
                    flex={false}
                    overflow={{ vertical: "auto" }}
                >
                    <TextArea
                        fill
                        size="10px"
                        value={recommand_text}
                        focusIndicator={false}
                        readOnly
                        plain
                    ></TextArea>
                </Box>
            </Box>
        );
    };

    return (
        <Box height="full">
            <PageMainCanvas>
                <Box
                    direction="row"
                    align="center"
                    width="full"
                    style={{ minHeight: "50px", maxHeight: "50px" }}
                >
                    <HiOutlineBuildingOffice size="30px" />
                    <Text size="20px">기관</Text>
                    <Box margin={{ left: "30px" }}>
                        <Button
                            focusIndicator={false}
                            plain
                            label={
                                <Box pad="10px">
                                    <Text size="15px">추가 검색</Text>
                                </Box>
                            }
                            icon={<Add size="15px" />}
                            onClick={() => setAddMoreInst(true)}
                            hoverIndicator
                        />
                    </Box>
                </Box>
                {readyLibraryTocs && <InstListBox />}
                <Box
                    width="full"
                    direction="row"
                    style={{ minHeight: "20px", maxHeight: "20px" }}
                    align="center"
                    justify="end"
                    alignSelf="end"
                >
                    {modificationMode ? (
                        <>
                            <Button
                                plain
                                hoverIndicator={{ color: "yellow" }}
                                focusIndicator={false}
                                icon={<ShareRounded size="15px" color="red" />}
                                label={
                                    <Box
                                        align="center"
                                        justify="center"
                                        pad="2px"
                                    >
                                        <Text
                                            size="12px"
                                            color="red"
                                            weight="bold"
                                        >
                                            자료수정 제안하기
                                        </Text>
                                    </Box>
                                }
                                onClick={() => setSendModification(true)}
                            />
                            <Button
                                plain
                                focusIndicator={false}
                                margin={{ left: "10px" }}
                                hoverIndicator={{ color: "yellow" }}
                                label={
                                    <Box
                                        align="center"
                                        justify="center"
                                        pad="2px"
                                    >
                                        <Text size="12px">자료수정 종료</Text>
                                    </Box>
                                }
                                icon={<Close size="13px" color="black" />}
                                onClick={() => setModificationMode(false)}
                            />
                        </>
                    ) : (
                        <Button
                            plain
                            hoverIndicator={{ color: "yellow" }}
                            icon={<StatusInfo size="15px" color="red" />}
                            label={
                                <Box align="center" justify="center" pad="2px">
                                    <Text size="12px" color="indigo">
                                        선택기관 자료수정
                                    </Text>
                                </Box>
                            }
                            onClick={() => startModification()}
                        />
                    )}
                </Box>
                <Box
                    width="full"
                    direction="row"
                    style={{ minHeight: "20px", maxHeight: "20px" }}
                    justify="between"
                    align="center"
                >
                    <Text size="10px">
                        전체 {instIds.length}개 / 자료 {showDataList.length}개
                    </Text>
                    <Text size="10px">
                        선택 {selectedInstIds.length}개 / 자료{" "}
                        <Text size="10px">
                            {instIds.length === selectedInstIds.length
                                ? showDataList.length
                                : filteredDataList.length}
                        </Text>
                        개
                    </Text>
                </Box>

                {readyShowList ? (
                    <Box
                        align="start"
                        justify="start"
                        overflow="auto"
                        width="full"
                        height="full"
                        border={{ side: "top", color: "black", size: "1px" }}
                        pad={{ top: "20px" }}
                    >
                        {showDataList.map((d: any) => (
                            <AData
                                data={d}
                                pindex={instInfos.findIndex(
                                    (p: any) => p.inst.inst_id === d.inst_id
                                )}
                                key={
                                    d.unit_id.toString() + d.inst_id.toString()
                                }
                            />
                        ))}
                    </Box>
                ) : (
                    <LoadingSign />
                )}
            </PageMainCanvas>
            {addMoreInst && (
                <Box
                    direction="column"
                    background="rgba(255,255,255,0.5)"
                    alignSelf="center"
                    align="center"
                    justify="center"
                >
                    <Layer
                        onClickOutside={() => setAddMoreInst(false)}
                        onEsc={() => setAddMoreInst(false)}
                        modal
                        full
                    >
                        <Box
                            align="start"
                            justify="start"
                            alignSelf="center"
                            width="full"
                            height="full"
                        >
                            <Box
                                margin={{ top: "50px" }}
                                alignSelf="end"
                                hoverIndicator
                                focusIndicator={false}
                                onClick={() => setAddMoreInst(false)}
                                height="50px"
                            >
                                <Button
                                    size="15px"
                                    icon={<Close size="15px" />}
                                    onClick={() => setAddMoreInst(false)}
                                />
                            </Box>
                            <Box
                                width="90%"
                                height="80%"
                                align="center"
                                alignSelf="center"
                            >
                                <SearchInstModal />
                            </Box>
                        </Box>
                    </Layer>
                </Box>
            )}
            {sendModification && (
                <Box
                    direction="column"
                    background="rgba(255,255,255,0.5)"
                    alignSelf="center"
                    align="center"
                    justify="center"
                >
                    <Layer
                        onClickOutside={() => setSendModification(false)}
                        onEsc={() => setSendModification(false)}
                        modal
                    >
                        <Box
                            align="start"
                            justify="start"
                            alignSelf="center"
                            width="full"
                            height="full"
                        >
                            <Box
                                margin={{ top: "50px" }}
                                alignSelf="end"
                                hoverIndicator
                                focusIndicator={false}
                                onClick={() => setAddMoreInst(false)}
                                height="50px"
                            >
                                <Button
                                    size="15px"
                                    icon={<Close size="15px" />}
                                    onClick={() => {
                                        setSendModification(false);
                                    }}
                                />
                            </Box>
                            <Box
                                width="90%"
                                height="80%"
                                align="center"
                                alignSelf="center"
                            >
                                <Text size="12px">
                                    아래 박스의 내용을 복사해서 관리자에게
                                    보내주세요
                                </Text>
                                {/* export newShowDataList by string */}
                                <Box
                                    width="full"
                                    height="full"
                                    overflow="auto"
                                    border={{
                                        side: "top",
                                        color: "black",
                                        size: "1px",
                                    }}
                                    pad={{ top: "20px" }}
                                    align="center"
                                    justify="start"
                                >
                                    <RecommandTextBox />
                                </Box>
                            </Box>
                        </Box>
                    </Layer>
                </Box>
            )}
        </Box>
    );
};

export default PageInstMain;
